<template>
  <div>
    <b-modal
      id="modal-scrollable"
      v-model="$store.state.someVariables.showUploadExcel"
      scrollable
      no-close-on-backdrop
      title="Cargar excel"
      cancel-variant="outline-secondary"
      @hidden="resetModal"
    >
      <b-row>
        <b-col md="12">
          <b-form-file
            v-model="file"
            placeholder="Selecciona o arrastra un archivo Excel"
            drop-placeholder="Arrastra un archivo excel"
          />

          <!-- <b-card-text class="my-1">
            Selected file: <strong>{{ file ? file.name : '' }}</strong>
          </b-card-text> -->
        </b-col>
      </b-row>
      <b-row class="mt-1" v-if="insertados != 0 && errorMaximo == 'no'">
        <b-col>
          <b-alert show variant="success">
            <div class="alert-body">
              <feather-icon class="mr-25" icon="CheckIcon" />
              <span class="ml-25"
                >{{ insertados }} JUGADORES se registraron con EXITO</span
              >
            </div>
          </b-alert>
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col>
          <b-alert
            show
            variant="danger"
            v-if="inconsitencias != null && errorMaximo == 'no'"
          >
            <div class="alert-body">
              <feather-icon class="mr-25" icon="AlertTriangleIcon" />
              <span class="ml-25"
                >{{ inconsitencias }} JUGADORES presentan inconsitencias</span
              >
            </div>
          </b-alert>
          <b-alert
            show
            variant="danger"
            v-if="inconsitencias != null && errorMaximo == 'si'"
          >
            <div class="alert-body">
              <feather-icon class="mr-25" icon="AlertTriangleIcon" />
              <span class="ml-25">{{ errorMessage }}</span>
            </div>
          </b-alert>
          <b-list-group>
            <b-list-group-item
              v-for="item in listInconsistentes"
              :key="item.id"
            >
              <span class="font-weight-bolder"
                >{{ item.cedula }} {{ item.apellidos }}
                {{ item.nombres }} </span
              ><br />
              <small class="notification-text">
                {{ item.mensaje }}
              </small>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
      <!-- <b-row class="mt-1">
        <b-col>
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            size="sm"
          >
            <feather-icon icon="UploadCloudIcon" class="mr-50" />
            <span class="align-middle">Subir</span>
          </b-button>
        </b-col>
      </b-row> -->
      <template #modal-footer>
        <div class="w-100">
          <template v-if="!showLoading">
            <b-button
              v-if="file != null"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="primary"
              size="sm"
              class="float-right"
              @click="uploadExcel"
            >
              <feather-icon icon="UploadCloudIcon" class="mr-50" />
              <span class="align-middle">Subir</span>
            </b-button>
          </template>
          <div v-if="showLoading" class="text-center mt-1">
            <b-spinner variant="primary" label="Text Centered" />
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import {
  BRow,
  BCol,
  BFormFile,
  //   BCardText,
  BButton,
  BAlert,
  BListGroup,
  BListGroupItem,
  BSpinner,
  //  xxx
} from 'bootstrap-vue'
import { URL, USER } from '../../utils/variables'
import apiCall from '../../utils/apiCall'

export default {
  components: {
    BRow,
    BCol,
    BFormFile,
    // BCardText,
    BButton,
    BAlert,
    BListGroup,
    BListGroupItem,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  props: {
    dataEquipo: Object,
  },
  setup(props, { emit }) {
    const file = ref(null)
    const listInconsistentes = ref([])
    const insertados = ref(null)
    const inconsitencias = ref(null)
    const errorMaximo = ref(null)
    const errorMessage = ref(null)
    const showLoading = ref(false)
    const { postApiFormData } = apiCall()
    async function uploadExcel() {
      showLoading.value = true
      const archivo = new FormData()
      archivo.append('file', file.value)
      archivo.append('id_equipo', props.dataEquipo.id_equipo)
      archivo.append('idUsuarioIngresa', USER().id_usuario)
      const path = 'ApiInscripciones/exel'
      const response = await postApiFormData(URL, path, archivo)
      listInconsistentes.value = response.inconsistentes
      insertados.value = response.insertados
      inconsitencias.value = listInconsistentes.value.length
      errorMaximo.value = response.errorMaximo
      errorMessage.value = response.maximo
      file.value = null
      showLoading.value = false
      emit('recargar', props.dataEquipo.id_equipo)
    }
    function resetModal(bvModalEvt) {
      bvModalEvt.preventDefault()
      // emit('recargar', props.dataEquipo.id_equipo)
      // console.log('hidden')
      listInconsistentes.value = []
      insertados.value = null
      inconsitencias.value = null
      errorMessage.value = null
      errorMaximo.value = null
      file.value = null
      showLoading.value = false
      // initPlayer()
      //       this.$emit('closeModal', false)
    }
    return {
      file,
      uploadExcel,
      listInconsistentes,
      insertados,
      inconsitencias,
      errorMaximo,
      errorMessage,
      resetModal,
      showLoading,
    }
  },
}
</script>
